import * as editHelper from "../../helpers/get_user_details";
import * as helper from "../../helpers/edit_user_data";

import { ShowFailedToast, ShowSuccessToast } from "../../../services/toast_handler";
import { SuccessUserEditResponse, failedToUpdateuser } from "../../../constants/error_messages";

import { EDIT_USER_DETAILS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getChannelsAddOnList, updateUserDetails } from "../../api/user_management";
import { notification } from "antd";
import { isJSON } from "../../../base/utils";
export const initialState = {
  editloading: false,
  responseError: {
    hasError: false,
    errorMessage: "",
  },
  isModelOpen: false,
  isEdited: false,
  currentUserDetails: {
    wholeData: {} as any,
    reportTo: {} as any,
    routingProfile: {} as any,
    skill: [] as any,
    channelList: {} as any,
    outBoundCall: 0,
    chatLimit: 0,
    domain_id: 0,
    ext: 0,
    primaryLanguage: {} as any,
    secondaryLanguage: [] as any,
    inboundCall :1,
    outboundCampaignCall :0,
    callHandling:0,
    is_outbound_campaign_specific_agent: 0
  },
  showError: false,
  getChannelsAddOnList: [] as any,

};

const EditUserSlice = createSlice({
  name: EDIT_USER_DETAILS,
  initialState,
  reducers: {
    initiateCancel: (state) => {
      state.isModelOpen = !state.isModelOpen;
    },
    setRoutingProfile: (state, { payload }) => {
      state.currentUserDetails.routingProfile = payload?.id ?? {};
      state.isEdited = true;
      state.currentUserDetails.domain_id = payload?.domain_id;
      state.currentUserDetails.ext = payload?.ext;
    },
    setreportTo: (state, { payload }) => {
      state.currentUserDetails.reportTo = payload ?? {};
      state.isEdited = true;
    },
    setPrimaryLanguage: (state, { payload }) => {
      const language = {
        addonId: payload.key,
          addonName: payload.value,
      }
      state.currentUserDetails.primaryLanguage = language ?? {};
      state.isEdited = true;
    },
    setChatLimit: (state, { payload }) => {
      state.currentUserDetails.chatLimit = payload ? parseInt(payload) : 0;
      state.isEdited = true;
    },
    skillSet: (state, { payload }) => {
      let dataArr: any = [];
      let value = payload.map((data: any) => {
        dataArr.push({
          skid: data.key,
          value: data.value,
        });
      });

      state.currentUserDetails.skill = dataArr;
      state.isEdited = true;
    },
    setSecondaryLanguage: (state, { payload }) => {
      let dataArr: any = [];
      let value = payload.map((data: any) => {
        dataArr.push({
          addonId: data.key,
          addonName: data.value,
        });
      });

      state.currentUserDetails.secondaryLanguage = dataArr;
      state.isEdited = true;
    },
    setChannel: (state, { payload }) => {
      state.currentUserDetails.channelList[payload] = state.currentUserDetails.channelList[payload] === 1 ? 0 : 1;
      state.showError = helper.showErrros(state.currentUserDetails.channelList);
      state.isEdited = true;
    },
    setCurrentUserData: (state, { payload }) => {
      state.currentUserDetails.wholeData = editHelper.setToUserData(payload);
      state.showError = helper.showErrros(state.currentUserDetails.channelList);
      state.currentUserDetails.channelList = helper.setchannelList(payload);  
      state.currentUserDetails.routingProfile = helper.routingProfile(payload);
      state.currentUserDetails.skill = helper.skill(payload);
      state.currentUserDetails.reportTo = helper.reportTo(payload);
      state.currentUserDetails.outBoundCall = helper.outBoundCall(payload);
      state.currentUserDetails.primaryLanguage = isJSON(payload?.primaryLanguage) ?  JSON.parse(payload?.primaryLanguage) : null;    
      state.currentUserDetails.secondaryLanguage =  isJSON(payload?.secondaryLanguage) ?  JSON.parse(payload?.secondaryLanguage) : null;
      state.currentUserDetails.inboundCall = payload?.inboundCall;
      state.currentUserDetails.outboundCampaignCall = payload?.outboundCampaignCall;
      state.currentUserDetails.is_outbound_campaign_specific_agent = payload?.is_outbound_campaign_specific_agent ?? 0;
      state.currentUserDetails.callHandling = helper?.callHandling(payload);

      state.isEdited = false;
    },
    setOutBoundCalls: (state, { payload }) => {
      state.currentUserDetails.outBoundCall = payload == 2 || payload == 3 ? 1 : 0;
      state.currentUserDetails.inboundCall = payload == 1 || payload == 3 ? 1 : 0;
      state.currentUserDetails.outboundCampaignCall = payload == 4 ? 1 : 0;
      state.currentUserDetails.callHandling = payload ;
      state.currentUserDetails.is_outbound_campaign_specific_agent = payload == 5 ? 1 : 0;
      state.isEdited = true;
    },

    reset: () => { },
  },

  extraReducers: (builder) => {
    builder.addCase(updateUserDetails.pending, (state) => {
      state.editloading = true;
    });
    builder.addCase(updateUserDetails.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.responseError.hasError = false;
        state.responseError.errorMessage = "";
        // ShowSuccessToast(SuccessUserEditResponse);
        notification.info({
          message: `${state.currentUserDetails.wholeData.name} Profile ${SuccessUserEditResponse}`,
          placement: "topRight",
          className: "toastNotification success",
          icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
          </svg>,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        });
      } else {
        state.responseError.hasError = true;
        state.responseError.errorMessage = payload?.message ?? failedToUpdateuser;
        //ShowFailedToast(failedToUpdateuser);
        notification.info({
          message: `${failedToUpdateuser} ${state.currentUserDetails.wholeData.name}`,
          placement: "topRight",
          className: "toastNotification error",
          icon: <span className="icon__Error24" />,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
          </svg>,
          duration: 3,
          top: 70,
        });
      }
      state.editloading = false;
    });
    builder.addCase(updateUserDetails.rejected, (state, { payload }: any) => {
      state.responseError.hasError = true;
      state.responseError.errorMessage = payload?.message ?? failedToUpdateuser;
      state.editloading = false;
    });
    builder.addCase(getChannelsAddOnList.fulfilled, (state, { payload }) => {
      state.getChannelsAddOnList = helper.getChannelsAddOnList(payload);
    });
  },
});
export const EdituserDetailsActions = EditUserSlice.actions;
export default EditUserSlice.reducer;
